<template>

  <el-row>
    <el-form ref="form" :model="form" size="small" label-width="120px">
      <el-row>
        <el-col :span="14">
          <el-form-item label="Centro Custo">
            <el-cascader style="width: 100%;"
                         v-model="form.centro_custo_id"
                         change-on-select
                         :options="centroCustolistTree"
                         :props="{label: 'nome' , value : 'id' }"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="Indicador Linha 1">
            <el-cascader style="width: 100%;"
                         v-model="form.indicador_linha_1"
                         change-on-select
                         :options="indicadorlistTree"
                         :props="{label: 'nome' , value : 'id' }"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="Indicador Linha 2">
            <el-cascader style="width: 100%;"
                         v-model="form.indicador_linha_2"
                         change-on-select
                         :options="indicadorlistTree"
                         :props="{label: 'nome' , value : 'id' }"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="Indicador Coluna">
            <el-cascader style="width: 100%;"
                         v-model="form.indicador_coluna"
                         change-on-select
                         :options="indicadorlistTree"
                         :props="{label: 'nome' , value : 'id' }"
            ></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click.prevent="aplicar()">Aplicar</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-col :span="5">
            <el-radio-group v-model="anoFilterSelected">
              <ul>
                <li v-for="item in anos">
                  <el-radio :label="item" :key="item" width="100%">{{item}}</el-radio>
                </li>
              </ul>
            </el-radio-group>
          </el-col>
          <el-col :span="5" class="mr-2">
            <el-checkbox-group v-model="mesesFilterSelecteds">
              <ul>
                <li v-for="item in meses">
                  <el-checkbox :label="item.mes" :key="item.mes" width="100%">{{item.nome}}</el-checkbox>
                </li>
              </ul>
            </el-checkbox-group>
          </el-col>
        </el-col>


      </el-row>
    </el-form>
  </el-row>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'

  export default {
    name: "FilterGraph",
    props: ['showfilter'],
    computed: {
      ...mapGetters(['centroCustolistTree', 'indicadorlistTree']),
      ...mapState(['anos', 'meses', 'mesSelected', 'anoSelected']),
    },
    data() {
      return {
        form: {},
        visible: false,
        anoFilterSelected: null,
        mesesFilterSelecteds: []
      }
    },
    watch: {
      showfilter: function (val, oldVal) {
        this.visible = val;
      },
      visible: function (val, oldVal) {
        this.$emit('update:showfilter', val)
      }
    },
    methods: {
      aplicar() {
        const {anoFilterSelected, mesesFilterSelecteds} = this
        this.$emit('filtroAplicado', {
          mesesSelecteds: mesesFilterSelecteds,
          anoSelected: anoFilterSelected,
          centroCustoSelected: _.last(this.form.centro_custo_id),
          indicadorLinha1Id: _.last(this.form.indicador_linha_1),
          indicadorLinha2Id: _.last(this.form.indicador_linha_2),
          indicadorColuna: _.last(this.form.indicador_coluna)
        })
        this.visible = false
      }
    },
    mounted() {
      this.anoFilterSelected = this.anoSelected
      this.mesesFilterSelecteds = collect(this.meses).pluck('mes').all()
      this.centrosSelecteds = collect(this.centroCustoList).pluck('id').all()
    }
  }
</script>

<style scoped>
  .el-checkbox-button .el-checkbox-button__inner {
    width: 100%;
  }

  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #ffffff !important;
  }
</style>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/Home/Graficos/LinhasPorColunaFilter.vue